import {Logger} from "platform/logger/Logger";
import Utils from "platform/util/Utils";

interface CustomerIOUser {

    id: number;
    email: string;
}

class CustomerIOWeb {

    private static readonly _logger: Logger = Logger.Of("CustomerIO");
    private static _queue: {event: string, data: any}[] = [];
    private static _user: CustomerIOUser;

    private constructor() {
    }

    public static identify = (user: CustomerIOUser) => {
        if (!this._user) {
            this._user = user;
            this._logger.debug("Identify");
            const cio = (window as any)._cio;
            if (cio) {
                cio.identify({
                    id: user.email,
                    email: user.email
                });
            }
            if (Utils.isArrayNotEmpty(this._queue)) {
                this._queue.forEach(({event, data}) => {
                    this.track(event, data);
                });
            }
            this._queue = [];
        } else {
            this._user = user;
        }
    }

    public static track = (event: string, data?: any) => {
        if (this._user) {
            const cio = (window as any)._cio;
            if (cio) {
                cio.track(this._user.email, event, data);
            }
        } else {
            this._queue.push({event, data});
        }
    }
}

export {
    CustomerIOUser,
    CustomerIOWeb
};
